// Deterministic, consistent color badge per staff member.
// The same staff id always maps to the same color across the Work Sheet grid
// and the Schedule pane for instant visual scanning.

const PALETTE = [
  { bg: "#E8F0E6", text: "#2F5233", solid: "#2F5233" }, // forest
  { bg: "#FBEFD9", text: "#A66A12", solid: "#D49A42" }, // ochre
  { bg: "#E0EEF2", text: "#1F5560", solid: "#3E7C8C" }, // teal
  { bg: "#F4E4EC", text: "#8A3B5C", solid: "#C16188" }, // rose
  { bg: "#EAE4F3", text: "#4B3B7C", solid: "#7C68C1" }, // purple
  { bg: "#FCE6E1", text: "#9C3B28", solid: "#D4684F" }, // terracotta
  { bg: "#E2F2EA", text: "#1F6B45", solid: "#34A56F" }, // green
  { bg: "#F4F0DE", text: "#7A6B12", solid: "#B5A02E" }, // gold
  { bg: "#E1ECF9", text: "#1E4E8C", solid: "#3E78C1" }, // blue
  { bg: "#F2E4F2", text: "#6B2C6B", solid: "#A04FA0" }, // magenta
  { bg: "#E6EAE0", text: "#4A5239", solid: "#6E7A52" }, // olive
  { bg: "#FBE8EE", text: "#A22C56", solid: "#D44E7C" }, // pink
];

function hashStr(s) {
  let h = 0;
  for (let i = 0; i < s.length; i += 1) {
    h = (h * 31 + s.charCodeAt(i)) >>> 0;
  }
  return h;
}

export function staffColor(id) {
  if (!id) return { bg: "#F0F0F0", text: "#555555", solid: "#999999" };
  return PALETTE[hashStr(String(id)) % PALETTE.length];
}
